import BsPeople from '@meronex/icons/bs/BsPeople';
import icon from './StyledIcon';
export default icon(BsPeople, {strokeWidth: '0.2px'});
